import React from 'react';
import PropTypes from 'prop-types';
import styles from './SearchNoResult.module.less';
import { DidYouMean } from './index';
import AppLink from '../links/AppLink';
import { useRouter } from 'next/router';
import { Image } from '../../edcom-ui';

function SearchNoResult({
  suggestions,
  handleClickSuggestion,
  currentFilter,
  title,
}) {
  const router = useRouter();
  return (
    <>
      <div className={styles.spacer}>
        <div className={styles.upperDiv}>
          <h2 className={styles.searchTitle}>
            {`No results found for "${currentFilter.q}"`}
            {title !== 'Educational Resources' && (
              <span>
                {`${currentFilter.q !== '' ? ` within ` : ''}${title}`}
              </span>
            )}
          </h2>
          {suggestions.length > 0 ? (
            <DidYouMean
              suggestions={suggestions}
              onClick={handleClickSuggestion}
            />
          ) : title !== 'Educational Resources' && currentFilter.q !== '' ? (
            <span>
              {'Go back: '}
              <AppLink href={router.asPath.split('?q=')[0]}>
                <span className={styles.mediumLink}>
                  {`Browse all ${title}`}
                </span>
              </AppLink>
            </span>
          ) : (
            <span>
              {'Try again: '}
              <AppLink href={'/resources/'}>
                <span className={styles.mediumLink}>
                  Browse the entire Learning Library
                </span>
              </AppLink>
            </span>
          )}
        </div>
        <div className={styles.searchResultContainer}>
          <div className={styles.lowerDiv}>
            <h5 className={styles.moreResultTitle}>Tips for searching:</h5>
            <ul className={styles.tryOptions}>
              <li>Use more general search terms</li>
              <li>Keep your search terms concise</li>
              <li>Double check the spelling</li>
            </ul>
            <span className={styles.fontChange}>
              {"Still can't find what you're looking for? "}
              <AppLink
                href="https://www.ixl.com/feedback/educationdotcom"
                className={styles.addUnderLine}
              >
                Share your feedback
              </AppLink>
              {' and help us improve.'}
            </span>
          </div>
          <div className={styles.gap}></div>
          <div className={styles.noResultRoly}>
            <Image
              src="https://cdn.education.com/files/static/characters/roly-explorer.svg"
              alt=""
            />
          </div>
        </div>
      </div>
    </>
  );
}

SearchNoResult.propTypes = {
  suggestions: PropTypes.array,
  handleClickSuggestion: PropTypes.func,
  currentFilter: PropTypes.object,
  title: PropTypes.string,
};

export default SearchNoResult;
